"use strict";Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.object.keys");require("core-js/modules/web.dom.iterable");require("core-js/modules/es6.number.constructor"); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default =
{
  data: function data() {
    return {
      searchData: {
        page: 1,
        rows: 10,
        brandName: '',
        brandCode: '',
        locale: '' },
      //筛选参数
      pageData: {
        page: 1,
        rows: 10,
        total: 0,
        pages: 1 },
      //分页数据
      brandList: [], //品牌列表
      languageList: [], //语言列表
      senderList: [], //发件人列表
      showAdd: false, //是否显示新增||编辑弹窗
      tableData: [], //表格数据
      tableColumn: [
      {
        prop: 'brandName',
        label: '品牌名称' },

      {
        prop: 'brandCode',
        label: '品牌编码' },

      {
        prop: 'title',
        label: '标题' },

      {
        prop: 'content',
        label: '发送文案' },

      {
        prop: 'sceneName',
        label: '发送类型' },

      {
        prop: 'localeType',
        label: '语言' }],

      //表头数据
      configForm: {
        id: '',
        brandId: '',
        title: '',
        content: '',
        type: '',
        locale: '',
        senderId: '' },
      //新增||编辑表单
      configFormRule: {
        brandId: [{
          required: true,
          message: '请选择品牌',
          trigger: ['change'] }],

        title: [{
          required: true,
          message: '请填写标题',
          trigger: ['change', 'blur'] }],

        content: [{
          required: true,
          message: '请填写文案',
          trigger: ['change', 'blur'] }],

        type: [{
          required: true,
          message: '请选择发送类型',
          trigger: ['change'] }],

        locale: [{
          required: true,
          message: '请选择语言',
          trigger: ['change'] }] },

      //表单校验规则
      sceneList: [
      {
        value: 'login',
        name: '登录' },

      {
        value: 'register',
        name: '注册' },

      {
        value: 'reset_pwd',
        name: '重置密码' },

      {
        value: 'reset',
        name: '重置' }],

      //发送类型列表
      showTemplate: false, //是否展示示例模板
      cnTemplate: "<h1>验证码#password#,您正在登录，若非本人操作，请勿泄露。</br>请勿泄露邮箱验证码</h1>",
      enTemplate: "Verfication code #password#,you are logged in, If you are not the user, Do not reveal the mailbox verification code" };

  },

  mounted: function mounted() {
    this.fetchList();
    this.fetchBrandList();
    this.fetchLanguageList();
    this.fetchSenderList();
  },

  methods: {
    /**
              * 配置列表
              */
    fetchList: function fetchList() {var _this = this;
      var params = Object.assign({}, this.searchData);
      this.getData('/api/baseMailTemplate/getPage', params, function (res) {
        _this.tableData = res.list;
        _this.pageData.page = res.pageNum;
        _this.pageData.total = res.total;
      });
    },

    /**
        * 获取语言列表
        */
    fetchLanguageList: function fetchLanguageList() {var _this2 = this;
      this.getData('/api/language/list', {}, function (res) {
        _this2.languageList = res;
      });
    },

    /**
        * 获取发件人列表
        */
    fetchSenderList: function fetchSenderList() {var _this3 = this;
      this.getData('/api/mailSender/getDownList', {}, function (res) {
        _this3.senderList = res;
      });
    },

    /**
        * 获取品牌列表
        */
    fetchBrandList: function fetchBrandList(query) {var _this4 = this;
      var params = {
        page: 1,
        rows: 9999 };

      this.getData('/api/faBrandInfo', params, function (res) {
        _this4.brandList = res.list;
      });
    },

    /**
        * 重置
        */
    onClickReset: function onClickReset() {
      this.$set(this.searchData, 'brandName', '');
      this.$set(this.searchData, 'brandCode', '');
      this.$set(this.searchData, 'locale', '');
      this.$set(this.searchData, 'page', 1);
      this.fetchList();
    },

    /**
        * size-change
        */
    handleSizeChange: function handleSizeChange(val) {
      this.$set(this.searchData, 'page', 1);
      this.$set(this.searchData, 'rows', val);
      this.fetchList();
    },

    /**
        * Page-change
        */
    handleCurrentChange: function handleCurrentChange(val) {
      this.$set(this.searchData, 'page', val);
      this.fetchList();
    },

    /**
        * 编辑
        */
    editItem: function editItem(row) {
      this.showAdd = true;
      this.$set(this.configForm, 'id', row.id);
      this.$set(this.configForm, 'brandId', row.brandId ? Number(row.brandId) : '');
      this.$set(this.configForm, 'title', row.title);
      this.$set(this.configForm, 'content', row.content);
      this.$set(this.configForm, 'type', row.type);
      this.$set(this.configForm, 'locale', row.locale);
      this.$set(this.configForm, 'senderId', row.senderId);
    },

    /**
        * 删除
        */
    delItem: function delItem(row) {var _this5 = this;
      this.$confirm('确定删除当前邮箱验证码配置？', '提示', { type: 'warning' }).then(function (res) {
        //删除通知
        _this5.delData("/api/baseMailTemplate/delete/".concat(row.id), {}, function (res) {
          _this5.fetchList();
        });
      }).catch(function (err) {

      });
    },

    /**
        * 弹窗打开
        */
    onAddDialogOpen: function onAddDialogOpen() {var _this6 = this;
      this.$nextTick(function () {
        _this6.$refs.configForm.clearValidate();
      });
    },

    /**
        * 新增||编辑弹窗关闭
        */
    onAddDialogClose: function onAddDialogClose() {var _this7 = this;
      this.$nextTick(function () {
        Object.keys(_this7.configForm).forEach(function (e) {
          _this7.$set(_this7.configForm, e, '');
        });
        _this7.$refs.configForm.clearValidate();
      });
      this.showAdd = false;
    },

    /**
        * 保存
        */
    onSaveConfig: function onSaveConfig() {var _this8 = this;
      this.$refs.configForm.validate(function (valid) {
        if (valid) {
          if (_this8.configForm.content.indexOf('#password#') < 0) {
            _this8.$message({
              type: 'error',
              message: '发送文案缺失#password#关键词' });

            return;
          }
          var params = Object.assign({}, _this8.configForm);
          if (params.id) {
            //编辑
            _this8.postData('/api/baseMailTemplate/update', params, function (res) {
              _this8.onAddDialogClose();
              _this8.fetchList();
            });
          } else {
            //新增
            delete params['id'];
            _this8.postData('/api/baseMailTemplate//save', params, function (res) {
              _this8.$set(_this8.searchData, 'page', 1);
              _this8.onAddDialogClose();
              _this8.fetchList();
            });
          }
        }
      });
    } } };exports.default = _default;